const menu = () => {

    let btnMenu = document.querySelector('.menu-sandwich');
    let menu = document.querySelector('header .menu');

    if (btnMenu && menu) {
        btnMenu.addEventListener('click', function (evt) {
            evt.preventDefault();
            if (menu.classList.contains('is-active')) {
                menu.classList.remove('is-active');
            } else {
                menu.classList.add('is-active');
            }

        })
    }

}

export {menu}
